import React, { useState,useEffect } from "react";
import axios from 'axios';
import api from './../../api';
import { useNavigate } from 'react-router-dom';
import './signInSignUp.css'
import Spinner from "../spinner/spinner";
import { useToast } from "../../ToastContext";
import translations from "../../translations";

const SERVER_URL = process.env.NODE_ENV === "development"
    ? "http://localhost:3000/api/v1/"
    : "/api/v2/";
const LoginPage = () => {
    const navigate = useNavigate();
    const [isLogin, setIsLogin] = useState(true);
    const [langOpt, setLangOpt] = useState(sessionStorage.getItem('langOpt') || 'Japanese');
    const [loading, setLoading] = useState(false);
    const { addToast } = useToast();
    const translate = (text) => {
        if (text) {
            return langOpt === 'Japanese' ? translations[text] : text;
        } else {
            return text
        }
    };
        const [formData, setFormData] = useState({
            firstName: "",
            lastName: "",
            employeeId:"",
            email: "",
            password: "",
            confirmPassword: ""
        });
        const [loginData, setLoginData] = useState({
            employeeId:"",
            password: "",
        });


    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');

        if (code && state && !sessionStorage.getItem('authCompleted')) {
            sessionStorage.setItem('authCompleted', 'true');
            window.location.href = `/oauth2/callback?code=${code}&state=${state}`;
        } else if (sessionStorage.getItem('authCompleted')) {
            window.location.href = '/dashboard';
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleLoginChange = (e) => {
        const { name, value } = e.target;
        setLoginData({ ...loginData, [name]: value });
    };
    const customLoginUser = async() =>{
        // const encryptedPassword = await bcrypt.hash(password, 10); // Hash password before sending
        let body = {
            employeeId: loginData.employeeId,
            password: loginData.password
        }
        try {
            setLoading(true);
            const response = await axios.post(`${SERVER_URL}auth/login`, body);
            console.log(response.data)
            if (response.data.token) {
                setLoading(false);
                sessionStorage.setItem("token", response.data.token); // Store JWT token

                sessionStorage.setItem('authCompleted', 'true');
                window.location.href = '/dashboard';
            }else{
                addToast(translate("Error occurred while Login"),"error")
            }
        } catch (error) {
            setLoading(false);
            console.error("Error logging in:", error);
            addToast(translate("Error occurred while Login"),"error")
        }
    }

    const handleLogin = () => {
        setIsLogin(!isLogin);
    }
    const handleSubmit = (e) => {
        e.preventDefault();

        }
    const loginUser = () =>{
        window.location.href = '/oauth2/start';
    }

    return (
        <>
            {loading && <Spinner />}
        {isLogin && <div className="login-container">
                <div className="login-header">
                    <img className="company-logo" src='./fuso-logo.svg' alt="fuso-logo"/>
                </div>
                <div className="login-header mt-1">
                    <p>Login to your account below</p>
                </div>
            <div className="custom-login-container">
                <input type='text' name='employeeId' placeholder='Employee Id' value={loginData.employeeId}
                       onChange={handleLoginChange}/>
                <input type='password' name='password' placeholder='Password' value={loginData.password}
                       onChange={handleLoginChange}/>
                <div className="login-button-container" onClick={customLoginUser}>
                    <span>Sign In</span>
                </div>
            </div>
            <div className="d-flex align-items-center gap-1">
                <hr className="w-100"/>
                OR
                <hr className="w-100"/>
            </div>
            <div className="login-button-container" onClick={loginUser}>
                <img src='./microsoft.svg' alt="Login"/>
                <span>Login with Microsoft</span>
            </div>
                <div className="login-header">
                    {/*<p>Dont have an account? <a className="blue-color" onClick={handleLogin} >Sign up</a></p>*/}
                </div>
            </div>}
            {/*------------------------------------Sign Up page-----------------------------------*/}
            {!isLogin && <div className="signup-container">
                <div className="signUp-header">
                    <img className="company-logo" src='./fuso-logo.svg'  alt="fuso-logo"/>
                </div>
                    <div className="signUp-header mt-3">
                    <h1>Sign up</h1>
                </div>
                <div className="signUp-header mt-1">
                    <p>Enter your details below to create your account and get started.</p>
                </div>
                <div className="signUp-form">
                    <form onSubmit={handleSubmit}>
                        <div className="form-container">
                            <div className="form-group">
                                <label >First Name</label>
                                <input
                                    type="text"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    placeholder="First Name"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Last Name</label>
                                <input
                                    type="text"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    placeholder="Last Name"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Employee Id</label>
                                <input
                                    type="text"
                                    name="employeeId"
                                    value={formData.employeeId}
                                    onChange={handleChange}
                                    placeholder="Employee Id"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Email"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Password</label>
                                <input
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    placeholder="Password"
                                    required
                                />
                            </div>
                            </div>
                        {/*<button type="submit">Sign Up</button>*/}
                    </form>
                </div>
                <div className="login-header">
                    <p>Already have an account? <a className="blue-color" onClick={handleLogin}>Login</a></p>
                </div>
            </div>}
        </>
    )
}

export default LoginPage;